/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/es';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Acceda al Editor HTML agradable"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Verificador de accesibilidad"
  },
  "action_to_take_b626a99a": {
    "message": "Acción por tomar:"
  },
  "add_8523c19b": {
    "message": "Agregar"
  },
  "add_a_caption_2a915239": {
    "message": "Agregar un subtítulo"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Agregar texto alternativo para la imagen"
  },
  "add_another_f4e50d57": {
    "message": "Agregar otro"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Agregar CC/subtítulos"
  },
  "add_image_60b2de07": {
    "message": "Agregar imagen"
  },
  "add_one_9e34a6f8": {
    "message": "Agregar uno."
  },
  "additional_considerations_f3801683": {
    "message": "Consideraciones adicionales"
  },
  "address_applied_64269b0b": {
    "message": "Dirección aplicada"
  },
  "address_removed_fcb496e0": {
    "message": "Dirección eliminada"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Los enlaces adyacentes con la misma URL deben ser un solo enlace."
  },
  "ai_response_9624e8e8": {
    "message": "Respuesta de IA"
  },
  "ai_tools_fda01177": {
    "message": "Herramientas de IA"
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Alinear"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Alineación y listas"
  },
  "all_4321c3a1": {
    "message": "Todo"
  },
  "all_apps_a50dea49": {
    "message": "Todas las aplicaciones"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabético"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "El texto del atributo alt no debe tener más de 120 caracteres."
  },
  "alt_text_611fb322": {
    "message": "Texto alternativo"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (coproducto)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Hubo un error al leer el archivo"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Se produjo un error al realizar una solicitud de red"
  },
  "an_error_occurred_processing_your_request_a3a38d84": {
    "message": "Se produjo un error al procesar su solicitud"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Se produjo un error al cargar sus elementos multimedia."
  },
  "and_7fcc2911": {
    "message": "Y"
  },
  "angle_c5b4ec50": {
    "message": "Ángulo"
  },
  "announcement_fb4cb645": {
    "message": "Anuncio"
  },
  "announcement_list_da155734": {
    "message": "Lista de anuncios"
  },
  "announcements_a4b8ed4a": {
    "message": "Anuncios"
  },
  "apply_781a2546": {
    "message": "Aplicar"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Aplicar los cambios a todas las instancias a este ícono de Icon Maker en el curso."
  },
  "approaches_the_limit_893aeec9": {
    "message": "Se acerca al límite"
  },
  "approximately_e7965800": {
    "message": "Aproximadamente"
  },
  "apps_54d24a47": {
    "message": "Aplicaciones"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "¿Confirma que quiere cancelar la operación? No se guardarán los cambios que realizó."
  },
  "arrows_464a3e54": {
    "message": "Flechas"
  },
  "art_icon_8e1daad": {
    "message": "Ícono de arte"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Se conservará la relación de aspecto"
  },
  "assignment_976578a8": {
    "message": "Tarea"
  },
  "assignments_1e02582c": {
    "message": "Tareas"
  },
  "asterisk_82255584": {
    "message": "Asterisco"
  },
  "attributes_963ba262": {
    "message": "Atributos"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "No se admite la grabación de audio y video; utilice un otro navegador."
  },
  "audio_options_feb58e2c": {
    "message": "Opciones de audio"
  },
  "audio_options_tray_33a90711": {
    "message": "Bandeja de opciones de audio"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Reproductor de audio para { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Hay contenido guardado automáticamente. ¿Desea cargar el contenido guardado automáticamente?"
  },
  "available_folders_694d0436": {
    "message": "Carpetas disponibles"
  },
  "background_1bc88842": {
    "message": "Fondo"
  },
  "backslash_b2d5442d": {
    "message": "Barra invertida"
  },
  "bar_ec63ed6": {
    "message": "Barra"
  },
  "basic_554cdc0a": {
    "message": "Básico"
  },
  "because_501841b": {
    "message": "Porque"
  },
  "below_81d4dceb": {
    "message": "Debajo"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Círculo grande"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Coeficiente binomial"
  },
  "black_4cb01371": {
    "message": "Negro"
  },
  "blue_daf8fea9": {
    "message": "Azul"
  },
  "bold_applied_42d547b7": {
    "message": "Negrita aplicada"
  },
  "bold_removed_da474a5c": {
    "message": "Negrita eliminada"
  },
  "border_5b08b06d": {
    "message": "Borde"
  },
  "bottom_15a2a9be": {
    "message": "Abajo"
  },
  "bottom_third_5f5fec1d": {
    "message": "Tercero desde abajo"
  },
  "bowtie_5f9629e4": {
    "message": "Pajarita"
  },
  "brick_f2656265": {
    "message": "Ladrillo"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Cancelar"
  },
  "cap_product_3a5265a6": {
    "message": "Extremo de producto"
  },
  "center_align_e68d9997": {
    "message": "Alineación central"
  },
  "centered_dot_64d5e378": {
    "message": "Punto centrado"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Puntos horizontales centrados"
  },
  "change_alt_text_92654906": {
    "message": "Texto alternativo de la imagen"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Cambiar etiqueta del título a párrafo"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Cambiar solo el nivel de este título"
  },
  "change_text_color_1aecb912": {
    "message": "Cambiar color del texto"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "No se guardarán los cambios que realizó."
  },
  "characters_9d897d1c": {
    "message": "Caracteres"
  },
  "characters_no_spaces_485e5367": {
    "message": "Caracteres (sin espacios)"
  },
  "check_accessibility_3c78211c": {
    "message": "Cambiar accesibilidad"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Comprobando problemas de accesibilidad"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Elegir archivo de subtítulos"
  },
  "choose_usage_rights_33683854": {
    "message": "Elegir derechos de uso..."
  },
  "circle_484abe63": {
    "message": "Círculo"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "marque con un círculo la lista no ordenada"
  },
  "clear_2084585f": {
    "message": "Eliminar"
  },
  "clear_image_3213fe62": {
    "message": "Imagen clara"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Haga clic o presione Mayús y haga clic para acceder al editor html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Haga clic para incluir { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Hacer clic para ocultar la vista previa"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Haz clic para insertar un enlace en el editor."
  },
  "click_to_show_preview_faa27051": {
    "message": "Hacer clic para mostrar la vista previa"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Cerrar un menú o diálogo. También lo vuelve a llevar al área de editor"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Cerrar verificador de accesibilidad"
  },
  "close_d634289d": {
    "message": "Cerrar"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "El archivo de subtítulos debe pesar menos de { maxKb } kB"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Subtítulos/subtítulos ocultos"
  },
  "clubs_suit_c1ffedff": {
    "message": "Bastos (palo)"
  },
  "collab_575ac7bc": {
    "message": "Colaborar"
  },
  "collaborations_5c56c15f": {
    "message": "Colaboraciones"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Colapsar para ocultar { types }"
  },
  "color_a363e1b0": {
    "message": "Color"
  },
  "color_contrast_4c418add": {
    "message": "Contraste de color"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Ratio de contraste de color"
  },
  "color_picker_6b359edf": {
    "message": "Selector de color"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Selector de color ({ colorName } seleccionado)"
  },
  "color_popup_af39810f": {
    "message": "Ventana emergente de color"
  },
  "column_e1ae5c64": {
    "message": "Columna"
  },
  "column_group_1c062368": {
    "message": "Grupo de columnas"
  },
  "complex_numbers_a543d004": {
    "message": "Números complejos"
  },
  "compose_44c904f4": {
    "message": "Componer"
  },
  "computer_1d7dfa6f": {
    "message": "Computadora"
  },
  "congruent_5a244acd": {
    "message": "Congruente"
  },
  "contains_311f37b7": {
    "message": "Contiene"
  },
  "content_1440204b": {
    "message": "Contenido"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "El contenido del editor se cambiará. Presione Cancelar para mantener el contenido original."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Todavía se está cargando el contenido; si continúa, no se incrustará correctamente."
  },
  "content_subtype_5ce35e88": {
    "message": "Subtipo de contenido"
  },
  "content_type_2cf90d95": {
    "message": "Tipo de contenido"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Continuar al contenido de YouTube"
  },
  "coproduct_e7838082": {
    "message": "Coproducto"
  },
  "copy_9748f9f": {
    "message": "Copiar"
  },
  "copyright_holder_66ee111": {
    "message": "Titular de los derechos de autor:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "No se pudo insertar el contenido: los ítems \"{ itemType }\" no se admiten actualmente en Canvas."
  },
  "count_40eced3b": {
    "message": "Conteo"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 palabras}\n    one {1 palabra}\n  other {# palabras}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# ítem cargado}\n  other {# ítems cargados}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Documentos del curso"
  },
  "course_files_62deb8f8": {
    "message": "Archivos del curso"
  },
  "course_files_a31f97fc": {
    "message": "Archivos del curso"
  },
  "course_images_f8511d04": {
    "message": "Imágenes del curso"
  },
  "course_link_b369426": {
    "message": "Enlace del curso"
  },
  "course_links_b56959b9": {
    "message": "Enlaces del curso"
  },
  "course_media_ec759ad": {
    "message": "Multimedia del curso"
  },
  "course_navigation_dd035109": {
    "message": "Navegación del curso"
  },
  "create_icon_110d6463": {
    "message": "Crear ícono"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Crear un ícono de Icon Maker"
  },
  "creative_commons_license_725584ae": {
    "message": "Licencia Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Delimitar imagen"
  },
  "crop_image_807ebb08": {
    "message": "Cortar imagen"
  },
  "cup_product_14174434": {
    "message": "Copa de producto"
  },
  "current_image_f16c249c": {
    "message": "Imagen actual"
  },
  "current_link_945a47ee": {
    "message": "Enlace actual"
  },
  "current_volume_level_c55ab825": {
    "message": "Nivel de volumen actual"
  },
  "custom_6979cd81": {
    "message": "Personalizar"
  },
  "custom_width_and_height_pixels_946eea7c": {
    "message": "Ancho y alto personalizado (píxeles)"
  },
  "cyan_c1d5f68a": {
    "message": "Cian"
  },
  "dagger_57e0f4e5": {
    "message": "Daga"
  },
  "date_added_ed5ad465": {
    "message": "Fecha de agregado"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Ícono decorativo"
  },
  "decorative_image_fde98579": {
    "message": "Imagen decorativa"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "{ TYPE_UPPER } decorativo"
  },
  "decrease_indent_d9cf469d": {
    "message": "Reducir sangría"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Reducir el área de contenido enriquecido"
  },
  "deep_purple_bb3e2907": {
    "message": "Morado oscuro"
  },
  "default_9db103d": {
    "message": "Por defecto"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "lista no ordenada con viñetas predeterminada"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "lista numérica ordenada predeterminada"
  },
  "definite_integral_fe7ffed1": {
    "message": "Integral definida"
  },
  "degree_symbol_4a823d5f": {
    "message": "Símbolo de grados"
  },
  "delimiters_4db4840d": {
    "message": "Delimitadores"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Describa el ícono)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Describir el { TYPE })"
  },
  "describe_the_video_2fe8f46a": {
    "message": "(Describir el video)"
  },
  "description_436c48d7": {
    "message": "Descripción"
  },
  "details_98a31b68": {
    "message": "Detalles"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Puntos diagonales"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamante"
  },
  "diamonds_suit_526abaaf": {
    "message": "Diamantes (palo)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Tipo de dimensión"
  },
  "dimensions_45ddb7b7": {
    "message": "Dimensiones"
  },
  "directionality_26ae9e08": {
    "message": "Direccionalidad"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Edición directa en LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Deshabilitar vista previa"
  },
  "discussion_6719c51d": {
    "message": "Foro de discusión"
  },
  "discussions_a5f96392": {
    "message": "Foros de discusión"
  },
  "discussions_index_6c36ced": {
    "message": "Índice de foros de discusión"
  },
  "disjoint_union_e74351a8": {
    "message": "Unión disjunta"
  },
  "dislike_14befc48": {
    "message": "Quitar Me gusta"
  },
  "display_options_315aba85": {
    "message": "Mostrar opciones"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Mostrar enlace de texto (se abre en una nueva pestaña)"
  },
  "div_applied_49ad83fc": {
    "message": "Div aplicado"
  },
  "div_removed_d13f8e17": {
    "message": "Div eliminado"
  },
  "division_sign_72190870": {
    "message": "Signo de dividir"
  },
  "document_678cd7bf": {
    "message": "Documento"
  },
  "documents_81393201": {
    "message": "Documentos"
  },
  "done_54e3d4b6": {
    "message": "Listo"
  },
  "double_dagger_faf78681": {
    "message": "Daga doble"
  },
  "down_5831a426": {
    "message": "Abajo"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Flecha diagonal hacia abajo y a la izquierda"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Flecha diagonal hacia abajo y a la derecha"
  },
  "download_filename_2baae924": {
    "message": "Descargar { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Flecha hacia abajo"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Triángulo apuntando hacia abajo"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Arrastrar un archivo aquí"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Arrastre y suelte, o haga clic para buscar en su computadora"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Icono de arrastre. Use las flechas arriba y abajo para cambiar el tamaño"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Fecha límite: Varias fechas"
  },
  "due_when_7eed10c6": {
    "message": "Fecha límite: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Editar texto alternativo para esta instancia de ícono"
  },
  "edit_c5fbea07": {
    "message": "Editar"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Editar enlace del curso"
  },
  "edit_equation_f5279959": {
    "message": "Editar ecuación"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Editar ícono de creación de íconos actual"
  },
  "edit_icon_2c6b0e91": {
    "message": "Editar ícono"
  },
  "edit_link_7f53bebb": {
    "message": "Editar enlace"
  },
  "editor_status_bar_653f44ee": {
    "message": "Barra de estado del editor"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Elemento que comienza con { start }"
  },
  "embed_828fac4a": {
    "message": "Incrustar"
  },
  "embed_code_314f1bd5": {
    "message": "Código de incrustación"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Incorporar contenido de herramienta externa"
  },
  "embed_image_1080badc": {
    "message": "Incorporar imagen"
  },
  "embed_video_a97a64af": {
    "message": "Incrustar video"
  },
  "embedded_content_aaeb4d3d": {
    "message": "contenido insertado"
  },
  "empty_set_91a92df4": {
    "message": "Conjunto vacío"
  },
  "encircled_dot_8f5e51c": {
    "message": "Punto en un círculo"
  },
  "encircled_minus_72745096": {
    "message": "Signo menos en un círculo"
  },
  "encircled_plus_36d8d104": {
    "message": "Signo más en un círculo"
  },
  "encircled_times_5700096d": {
    "message": "Veces en un círculo"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ícono de ingeniería"
  },
  "english_icon_25bfe845": {
    "message": "Ícono de ingles"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Ingresar al menos 3 caracteres para buscar"
  },
  "enter_replacement_text_17631bbc": {
    "message": "ingresar texto de reemplazo"
  },
  "enter_search_text_26cb4459": {
    "message": "ingresar texto de búsqueda"
  },
  "enter_text_8b35c65b": {
    "message": "Ingresar texto"
  },
  "epsilon_54bb8afa": {
    "message": "Épsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Épsilon (variante)"
  },
  "equals_sign_c51bdc58": {
    "message": "Signo igual"
  },
  "equation_1c5ac93c": {
    "message": "Ecuación"
  },
  "equation_editor_39fbc3f1": {
    "message": "Editor de ecuaciones"
  },
  "equilibrium_6ff3040b": {
    "message": "Equilibrio"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Clase de equivalencia"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Equivalente (identidad)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Existe"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Salir de la pantalla completa"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Expandir vista previa de forma predeterminada"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Expandir para ver { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Enlace externo"
  },
  "external_tool_frame_70b32473": {
    "message": "Marco de herramientas externas"
  },
  "external_tools_6e77821": {
    "message": "Herramientas externas"
  },
  "extra_large_b6cdf1ff": {
    "message": "Extra grande"
  },
  "extra_small_9ae33252": {
    "message": "Extra pequeño"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Ícono extracurricular"
  },
  "f_function_fe422d65": {
    "message": "F (función)"
  },
  "fail_544e5dde": {
    "message": "FALLA"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Error al obtener el contenido del archivo"
  },
  "failed_to_copy_response_d3def551": {
    "message": "Error al copiar la respuesta"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "No se pudo recuperar el contenido de la herramienta externa"
  },
  "file_name_8fd421ff": {
    "message": "Nombre del archivo"
  },
  "file_preview_21667a6e": {
    "message": "Vista previa del archivo"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Vista previa del archivo de { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Capacidad de almacenamiento de archivos excedida"
  },
  "file_url_c12b64be": {
    "message": "URL del archivo"
  },
  "filename_file_icon_602eb5de": {
    "message": "Icono del archivo { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Vista previa de la imagen { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Vista previa del texto { filename }"
  },
  "files_c300e900": {
    "message": "Archivos"
  },
  "files_index_af7c662b": {
    "message": "Índice de archivos"
  },
  "find_8d605019": {
    "message": "Encontrar"
  },
  "find_and_replace_6e345933": {
    "message": "Buscar y reemplazar"
  },
  "finish_bc343002": {
    "message": "Terminar"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Fijar jerarquía de títulos"
  },
  "flat_music_76d5a5c3": {
    "message": "Bemol (música)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Barra de herramientas de opciones para enfocarse en un elemento"
  },
  "folder_tree_fbab0726": {
    "message": "Árbol de carpetas"
  },
  "for_all_b919f972": {
    "message": "Para todos"
  },
  "format_4247a9c5": {
    "message": "Formato"
  },
  "format_as_a_list_142210c3": {
    "message": "Formatear como lista"
  },
  "formatting_5b143aa8": {
    "message": "Formato"
  },
  "forward_slash_3f90f35e": {
    "message": "Barra inclinada"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Se encontró contenido guardado automáticamente"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Se encontraron { count, plural,\n     =0 {# resultados}\n    one {# resultado}\n  other {# resultados}\n}"
  },
  "fraction_41bac7af": {
    "message": "Fracción"
  },
  "fullscreen_873bf53f": {
    "message": "Pantalla completa"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Generando la vista previa..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Actualmente no se admiten imágenes en formato GIF/PNG de más de { size } KB."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Ir a la barra de menú del editor"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Ir a la barra de herramientas del editor"
  },
  "grades_a61eba0a": {
    "message": "Calificaciones"
  },
  "graphics_text_bc9568bc": {
    "message": "Texto gráfico"
  },
  "greater_than_e98af662": {
    "message": "Mayor a"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Mayor o igual a"
  },
  "greek_65c5b3f7": {
    "message": "Griego"
  },
  "green_15af4778": {
    "message": "Verde"
  },
  "grey_a55dceff": {
    "message": "Gris"
  },
  "group_documents_8bfd6ae6": {
    "message": "Documentos del grupo"
  },
  "group_files_4324f3df": {
    "message": "Archivos grupales"
  },
  "group_files_82e5dcdb": {
    "message": "Archivos del grupo"
  },
  "group_images_98e0ac17": {
    "message": "Imágenes del grupo"
  },
  "group_isomorphism_45b1458c": {
    "message": "Isomorfismo de grupos"
  },
  "group_link_63e626b3": {
    "message": "Enlace del grupo"
  },
  "group_links_9493129e": {
    "message": "Enlaces del grupo"
  },
  "group_media_2f3d128a": {
    "message": "Elementos multimedia del grupo"
  },
  "group_navigation_99f191a": {
    "message": "Navegación del grupo"
  },
  "h_bar_bb94deae": {
    "message": "Barra H"
  },
  "hat_ea321e35": {
    "message": "Sombrero"
  },
  "header_column_f27433cb": {
    "message": "Columna de encabezado"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Fila y columna de encabezado"
  },
  "header_row_f33eb169": {
    "message": "Fila de encabezado"
  },
  "heading_2_5b84eed2": {
    "message": "Encabezado 2"
  },
  "heading_3_2c83de44": {
    "message": "Encabezado 3"
  },
  "heading_4_b2e74be7": {
    "message": "Encabezado 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Título { h } aplicado"
  },
  "heading_h_removed_745f24a6": {
    "message": "Título { h } eliminado"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Los niveles de los títulos no deben omitirse."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Título que comienza con { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Los títulos no deben tener más de 120 caracteres."
  },
  "health_icon_8d292eb5": {
    "message": "Ícono de salud"
  },
  "hearts_suit_e50e04ca": {
    "message": "Corazones (palo)"
  },
  "height_69b03e15": {
    "message": "Altura"
  },
  "hello_please_describe_the_modifications_you_would__49b19837": {
    "message": "Hola. Describa las modificaciones que le gustaría realizar en su composición."
  },
  "hello_please_describe_the_modifications_you_would__600dbbf0": {
    "message": "Hola. Describa las modificaciones que le gustaría realizar en su selección."
  },
  "hexagon_d8468e0d": {
    "message": "Hexágono"
  },
  "hide_description_bfb5502e": {
    "message": "Ocultar descripción"
  },
  "hide_title_description_caf092ef": {
    "message": "Ocultar descripción { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Resalte un elemento para activar la barra de herramientas de opciones del elemento"
  },
  "home_351838cd": {
    "message": "Página de inicio"
  },
  "html_code_editor_fd967a44": {
    "message": "editor de código html"
  },
  "html_editor_fb2ab713": {
    "message": "Editor HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "He obtenido permiso para utilizar este archivo."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Soy el titular de los derechos de autor"
  },
  "i_m_sorry_but_i_cannot_find_the_ai_s_answer_67569d19": {
    "message": "Lo siento, no encuentro la respuesta de la IA."
  },
  "icon_215a1dc6": {
    "message": "Ícono"
  },
  "icon_8168b2f8": {
    "message": "ícono"
  },
  "icon_color_b86dd6d6": {
    "message": "Ícono de color"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Íconos de Icon Maker"
  },
  "icon_options_7e32746e": {
    "message": "Opciones de ícono"
  },
  "icon_options_tray_2b407977": {
    "message": "Bandeja de opciones de íconos"
  },
  "icon_preview_1782a1d9": {
    "message": "Vista preliminar del ícono"
  },
  "icon_shape_30b61e7": {
    "message": "Forma del ícono"
  },
  "icon_size_9353edea": {
    "message": "Tamaño del ícono"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Si se deja vacío, el texto del enlace se mostrará como el nombre del enlace del curso."
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Si se requieren derechos de uso, no se publicará el archivo hasta que esté habilitado en la página de Archivos."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Si no selecciona los derechos de uso en este momento, se cancelará la publicación de este archivo después de cargarlo."
  },
  "image_8ad06": {
    "message": "Imagen"
  },
  "image_c1c98202": {
    "message": "imagen"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Los nombres de archivo de las imágenes no deben usarse como el atributo alt que describe el contenido de la imagen."
  },
  "image_options_5412d02c": {
    "message": "Opciones de imagen"
  },
  "image_options_tray_90a46006": {
    "message": "Bandeja de opciones de imagen"
  },
  "image_to_crop_3a34487d": {
    "message": "Imagen para recortar"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Imagen con nombre de archivo { file }"
  },
  "images_7ce26570": {
    "message": "Imágenes"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Las imágenes deben incluir un atributo alt que describa el contenido de la imagen."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Parte imaginaria (de números complejos)"
  },
  "in_element_of_19ca2f33": {
    "message": "En (elemento de)"
  },
  "increase_indent_6af90f7c": {
    "message": "Aumentar sangría"
  },
  "increase_rich_content_area_340b775": {
    "message": "Aumentar el área de contenido enriquecido"
  },
  "indefinite_integral_6623307e": {
    "message": "Integral indefinida"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } de { max }"
  },
  "indigo_2035fc55": {
    "message": "Índigo"
  },
  "inference_fed5c960": {
    "message": "Inferencia"
  },
  "infinity_7a10f206": {
    "message": "Infinito"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Campo de entrada para alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Campo de entrada para azul"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Campo de entrada para verde"
  },
  "input_field_for_red_86a84615": {
    "message": "Campo de entrada para rojo"
  },
  "insert_593145ef": {
    "message": "Insertar"
  },
  "insert_link_6dc23cae": {
    "message": "Insertar enlace"
  },
  "insert_math_equation_57c6e767": {
    "message": "Insertar la ecuación matemática"
  },
  "integers_336344e1": {
    "message": "Enteros"
  },
  "intersection_cd4590e4": {
    "message": "Intersección"
  },
  "invalid_description_991e23bb": {
    "message": "Descripción no válida"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Ingreso no válido."
  },
  "invalid_file_c11ba11": {
    "message": "Archivo inválido"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Tipo de archivo inválido"
  },
  "invalid_url_cbde79f": {
    "message": "URL inválida"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Problema { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Cursiva aplicada"
  },
  "italic_removed_17cbab6f": {
    "message": "Cursiva eliminada"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (variante)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Acceso rápido de teclado"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Los teclados navegan por los enlaces mediante la tecla Tab. Dos enlaces adyacentes que dirigen al mismo destino pueden ser confusos para los usuarios del teclado."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Ícono de artes del lenguaje"
  },
  "languages_icon_9d20539": {
    "message": "Ícono de idiomas"
  },
  "large_9c5e80e7": {
    "message": "Grande"
  },
  "large_text_e7ba08cd": {
    "message": "Texto grande"
  },
  "learn_ad3b3505": {
    "message": "Aprender"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Obtenga más información sobre los enlaces adyacentes"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Obtenga más información sobre el contraste de colores"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Obtenga más información sobre la organización de los títulos de página"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Obtenga más información sobre la estructura correcta de los títulos de página"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Obtenga más información sobre los títulos de tablas"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Obtenga más información sobre texto alternativo para las imágenes"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Obtenga más información sobre el uso de leyendas con tablas"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Obtenga más información sobre el uso de nombres de archivo como texto alternativo"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Obtenga más información sobre el uso de listas"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Obtenga más información sobre el uso de atributos de alcance con tablas"
  },
  "leave_as_is_4facfe55": {
    "message": "Dejar sin cambios"
  },
  "left_3ea9d375": {
    "message": "Izquierda"
  },
  "left_align_43d95491": {
    "message": "Alineación a la izquierda"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Símbolo de mayor"
  },
  "left_arrow_4fde1a64": {
    "message": "Flecha izquierda"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Flecha izquierda con gancho"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Techo izquierdo"
  },
  "left_curly_brace_1726fb4": {
    "message": "Llave izquierda"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Flecha de arpón hacia abajo y a la izquierda"
  },
  "left_floor_29ac2274": {
    "message": "Piso izquierdo"
  },
  "left_to_right_e9b4fd06": {
    "message": "Izquierda a derecha"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Flecha de arpón hacia arriba y a la izquierda"
  },
  "leftward_arrow_1e4765de": {
    "message": "Flecha hacia la izquierda"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Triángulo apuntando hacia la izquierda"
  },
  "less_than_a26c0641": {
    "message": "Menor a"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Menor o igual a"
  },
  "library_icon_ae1e54cf": {
    "message": "Ícono de biblioteca"
  },
  "light_blue_5374f600": {
    "message": "Azul claro"
  },
  "link_7262adec": {
    "message": "Enlace"
  },
  "link_options_a16b758b": {
    "message": "Opciones de enlace"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "tipo de enlace: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Vincular con texto que comienza con { start }"
  },
  "links_14b70841": {
    "message": "Enlaces"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Enlaces a un sitio externo."
  },
  "lists_cd1336fc": {
    "message": "Listas"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Las listas deben tener el formato de listas."
  },
  "load_more_35d33c7": {
    "message": "Cargar más"
  },
  "loading_25990131": {
    "message": "Cargando..."
  },
  "loading_bde52856": {
    "message": "Cargando"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Error al cargar subtítulos."
  },
  "loading_external_tool_d839042c": {
    "message": "Cargando herramienta externa"
  },
  "loading_failed_b3524381": {
    "message": "La carga falló..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Falló la carga."
  },
  "loading_folders_d8b5869e": {
    "message": "Cargando carpetas"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Cargando marcador de posición para { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Cargando, espere"
  },
  "loading_preview_9f077aa1": {
    "message": "Carga de la vista previa"
  },
  "locked_762f138b": {
    "message": "Bloqueado"
  },
  "logical_equivalence_76fca396": {
    "message": "Equivalencia lógica"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Equivalencia lógica (corta)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Equivalencia lógica (corta y gruesa)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Equivalencia lógica (gruesa)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Puntos horizontales bajos"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Mapas a"
  },
  "math_icon_ad4e9d03": {
    "message": "Ícono de matemáticas"
  },
  "media_af190855": {
    "message": "Multimedia"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "El archivo multimedia se está procesando. Inténtelo de nuevo más tarde."
  },
  "media_title_2112243b": {
    "message": "Título del elemento multimedia"
  },
  "medium_5a8e9ead": {
    "message": "Regular"
  },
  "merge_links_2478df96": {
    "message": "Fusionar enlaces"
  },
  "mic_a7f3d311": {
    "message": "Micrófono"
  },
  "microphone_disabled_15c83130": {
    "message": "Micrófono desactivado"
  },
  "middle_27dc1d5": {
    "message": "El medio"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimice la vista previa del archivo"
  },
  "minimize_video_20aa554b": {
    "message": "Minimice el video"
  },
  "minus_fd961e2e": {
    "message": "Menos"
  },
  "minus_plus_3461f637": {
    "message": "Menos/más"
  },
  "misc_3b692ea7": {
    "message": "Varios"
  },
  "miscellaneous_e9818229": {
    "message": "Misceláneo"
  },
  "modify_6b0b13e3": {
    "message": "Modificar"
  },
  "module_90d9fd32": {
    "message": "Módulo"
  },
  "modules_c4325335": {
    "message": "Módulos"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Moviendo imagen para cortar { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Imagen multicolor"
  },
  "multiplication_sign_15f95c22": {
    "message": "Signo de multiplicación"
  },
  "music_icon_4db5c972": {
    "message": "Ícono de música"
  },
  "my_files_2f621040": {
    "message": "Mis archivos"
  },
  "n_th_root_9991a6e4": {
    "message": "Raíz n-ésima"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nombre"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Nota natural (música)"
  },
  "natural_numbers_3da07060": {
    "message": "Números naturales"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navegar por el menú o la barra de herramientas"
  },
  "navigation_ee9af92d": {
    "message": "Navegación"
  },
  "nested_greater_than_d852e60d": {
    "message": "Anidado mayor a"
  },
  "nested_less_than_27d17e58": {
    "message": "Anidado menor a"
  },
  "new_quiz_34aacba6": {
    "message": "Nueva evaluación"
  },
  "next_40e12421": {
    "message": "Siguiente"
  },
  "next_findtext_9d69f0fe": {
    "message": "El próximo { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "No se detectaron problemas de accesibilidad."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Todavía no se ha creado ningún anuncio."
  },
  "no_announcements_found_20185afc": {
    "message": "No se han encontrado anuncios."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Todavía no se ha creado ninguna tarea."
  },
  "no_assignments_found_79e46d7f": {
    "message": "No encontramos tareas."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "No hay cambios para guardar."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Todavía no se ha creado ningún debate."
  },
  "no_discussions_found_9284063b": {
    "message": "No se ha encontrado ningún debate."
  },
  "no_e16d9132": {
    "message": "No"
  },
  "no_file_chosen_9a880793": {
    "message": "No se seleccionó ningún archivo"
  },
  "no_headers_9bc7dc7f": {
    "message": "Sin encabezados"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Todavía no se ha creado ningún módulo."
  },
  "no_modules_found_2df43a40": {
    "message": "No se ha encontrado ningún módulo."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Todavía no se ha creado ninguna página."
  },
  "no_pages_found_6799350": {
    "message": "No se ha encontrado ninguna página."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "La vista previa de este archivo no está disponible."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Todavía no se han creado evaluaciones."
  },
  "no_quizzes_found_c80c537a": {
    "message": "No se han encontrado evaluaciones."
  },
  "no_results_940393cf": {
    "message": "No hay resultados."
  },
  "no_results_found_58717065": {
    "message": "No se encontraron resultados"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "No se encontraron resultados para { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "No hay video"
  },
  "none_3b5e34d2": {
    "message": "Ninguno"
  },
  "none_selected_b93d56d2": {
    "message": "Nada seleccionado"
  },
  "normal_text_7b03da48": {
    "message": "Texto normal"
  },
  "not_equal_6e2980e6": {
    "message": "No igual"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "No en (no es un elemento de)"
  },
  "not_negation_1418ebb8": {
    "message": "No (negación)"
  },
  "not_subset_dc2b5e84": {
    "message": "No es un subconjunto"
  },
  "not_subset_strict_23d282bf": {
    "message": "No es un subconjunto (estricto)"
  },
  "not_superset_5556b913": {
    "message": "No es un superconjunto"
  },
  "not_superset_strict_24e06f36": {
    "message": "No es un superconjunto (estricto)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Octágono"
  },
  "olive_6a3e4d6b": {
    "message": "Verde oliva"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Se debe agregar uno de los siguientes estilos para guardar un ícono: Color del ícono, tamaño del contorno, texto del ícono o imagen"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Error al pegar uno o más archivos. Intente cargar o arrastrar y soltar los archivos."
  },
  "open_circle_e9bd069": {
    "message": "Círculo abierto"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Abrir esta ventana de diálogo de atajos de teclado"
  },
  "open_title_application_fd624fc5": {
    "message": "Abrir aplicación { title }"
  },
  "operators_a2ef9a93": {
    "message": "Operadores"
  },
  "options_3ab0ea65": {
    "message": "Opciones"
  },
  "or_9b70ccaa": {
    "message": "O"
  },
  "orange_81386a62": {
    "message": "Anaranjado"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Listas ordenadas y no ordenadas"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Puede encontrar otros atajos de editor en"
  },
  "outline_color_3ef2cea7": {
    "message": "Color de contorno"
  },
  "outline_size_a6059a21": {
    "message": "Tamaño de contorno"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } no es un protocolo válido."
  },
  "page_50c4823d": {
    "message": "Página"
  },
  "pages_e5414c2c": {
    "message": "Páginas"
  },
  "paragraph_5e5ad8eb": {
    "message": "Párrafo"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Párrafo aplicado"
  },
  "paragraph_removed_d09320e": {
    "message": "Párrafo eliminado"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Párrafo que comienza con { start }"
  },
  "parallel_d55d6e38": {
    "message": "Paralelo"
  },
  "partial_derivative_4a9159df": {
    "message": "Parcial (derivada)"
  },
  "pass_1c19a2b3": {
    "message": "APROBADO"
  },
  "paste_5963d1c1": {
    "message": "Pegar"
  },
  "pause_12af3bb4": {
    "message": "Pausar"
  },
  "pentagon_17d82ea3": {
    "message": "Pentágono"
  },
  "people_b4ebb13c": {
    "message": "Personas"
  },
  "percentage_34ab7c2c": {
    "message": "Porcentaje"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "El porcentaje debe ser un número"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "El porcentaje debe ser de al menos { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Ícono de artes escénicas"
  },
  "perpendicular_7c48ede4": {
    "message": "Perpendicular"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (variante)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ícono de educación física"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (variante)"
  },
  "pick_a_color_557abfb0": {
    "message": "Elija un color"
  },
  "pink_68ad45cb": {
    "message": "Rosado"
  },
  "pixels_52ece7d1": {
    "message": "Pixeles"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Los píxeles deben ser al menos { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Reproducir"
  },
  "play_media_comment_35257210": {
    "message": "Reproducir comentario de multimedia."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Reproducir comentario multimedia de { name } desde { createdAt }."
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Deje que Canvas acceda a su micrófono y cámara web."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Elija un archivo"
  },
  "please_decribe_what_you_would_like_to_compose_27a51be5": {
    "message": "Describa lo que le gustaría componer."
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Ingrese el nombre del archivo"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Ingrese una URL de video válida de una plataforma compatible."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Seleccione un archivo compatible"
  },
  "plus_d43cd4ec": {
    "message": "Más"
  },
  "plus_minus_f8be2e83": {
    "message": "Más/menos"
  },
  "posted_when_a578f5ab": {
    "message": "Publicado: { when }"
  },
  "power_set_4f26f316": {
    "message": "Conjunto potencia"
  },
  "precedes_196b9aef": {
    "message": "Precede"
  },
  "precedes_equal_20701e84": {
    "message": "Precede al igual"
  },
  "preformatted_d0670862": {
    "message": "Previamente formateado"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Previo"
  },
  "preview_53003fd2": {
    "message": "Vista previa"
  },
  "preview_a3f8f854": {
    "message": "VISTA PREVIA"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Vista previa en superposición"
  },
  "preview_inline_9787330": {
    "message": "Vista previa en línea"
  },
  "previous_bd2ac015": {
    "message": "Anterior"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Anterior { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Colores seleccionados previamente"
  },
  "prime_917ea60e": {
    "message": "Primo"
  },
  "prime_numbers_13464f61": {
    "message": "Números primos"
  },
  "product_39cf144f": {
    "message": "Producto"
  },
  "proportional_f02800cc": {
    "message": "Proporcional"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "El protocolo debe ser ftp, http, https, mailto, skype, tel, o puede omitirse"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "publicado"
  },
  "published_when_302d8e23": {
    "message": "Publicado: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Calabaza"
  },
  "purple_7678a9fc": {
    "message": "Morado"
  },
  "quaternions_877024e0": {
    "message": "Cuaterniones"
  },
  "quiz_e0dcce8f": {
    "message": "Evaluación"
  },
  "quizzes_7e598f57": {
    "message": "Exámenes"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Números racionales"
  },
  "real_numbers_7c99df94": {
    "message": "Números reales"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Parte real (de números complejos)"
  },
  "record_7c9448b": {
    "message": "Grabar"
  },
  "record_upload_media_5fdce166": {
    "message": "Grabar/cargar contenido multimedia"
  },
  "recording_98da6bda": {
    "message": "Grabación"
  },
  "red_8258edf3": {
    "message": "Rojo"
  },
  "relationships_6602af70": {
    "message": "Relaciones"
  },
  "religion_icon_246e0be1": {
    "message": "Ícono de religión"
  },
  "remove_f47dc62a": {
    "message": "Borrar"
  },
  "remove_filename_3ea029f6": {
    "message": "Borrar { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Eliminar estilo del título"
  },
  "remove_link_d1f2f4d0": {
    "message": "Eliminar enlace"
  },
  "remove_studio_media_f913e502": {
    "message": "Eliminar los archivos multimedia de Studio"
  },
  "replace_all_d3d68b3": {
    "message": "Reemplazar todo"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Reemplazar todo { findText } por { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Reemplazar"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Reemplazar { findText } por { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Reemplazar por"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Reemplazado { alertFindText } por { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Reemplazado todo { alertFindText } por { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Restablecer"
  },
  "resize_ec83d538": {
    "message": "Redimensionar"
  },
  "response_copied_to_clipboard_130d66cd": {
    "message": "Respuesta copiada al portapapeles"
  },
  "restore_auto_save_deccd84b": {
    "message": "¿Desea restablecer el guardado automático?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Resultado { index } de { max }."
  },
  "retry_ebd5f8ba": {
    "message": "Reintentar"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Trinquete invertido (no da resultados)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (variante)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Editor de Contenido Enriquecido"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Área del texto enriquecido. Presione { OSKey }+F8 para acceder a los atajos del Editor de contenido enriquecido."
  },
  "right_71ffdc4d": {
    "message": "Derecha"
  },
  "right_align_39e7a32a": {
    "message": "Alineación a la derecha"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Símbolo de menor"
  },
  "right_arrow_35e0eddf": {
    "message": "Flecha a la derecha"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Flecha a la izquierda con gancho"
  },
  "right_ceiling_839dc744": {
    "message": "Techo derecho"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Llave derecha"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Flecha de arpón hacia abajo y a la derecha"
  },
  "right_floor_5392d5cf": {
    "message": "Piso derecho"
  },
  "right_to_left_9cfb092a": {
    "message": "Derecha a izquierda"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Flecha de arpón hacia arriba y a la derecha"
  },
  "rightward_arrow_32932107": {
    "message": "Flecha hacia la derecha"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Triángulo apuntando hacia la derecha"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Rotar imagen -90 grados"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Rotar imagen 90 grados"
  },
  "rotation_9699c538": {
    "message": "Rotación"
  },
  "row_fc0944a7": {
    "message": "Fila"
  },
  "row_group_979f5528": {
    "message": "Grupo de filas"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Lamentablemente, no se puede acceder al Editor HTML agradable desde el teclado. Acceda al Editor de HTML sin formato aquí."
  },
  "save_11a80ec3": {
    "message": "Guardar"
  },
  "save_copy_ca63944e": {
    "message": "Guardar copia"
  },
  "save_media_cb9e786e": {
    "message": "Guardar multimedia"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Íconos de Icon Maker guardados"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Los lectores de pantalla no pueden determinar lo que se muestra en una imagen sin texto alternativo, y los nombres de archivo con frecuencia son secuencias de números y letras sin sentido que no describen el contexto o significado."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Los lectores de pantalla no pueden determinar lo que se muestra en una imagen sin texto alternativo, el cual describe el contexto y el significado de la imagen. El texto alternativo debe ser simple y conciso."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Los lectores de pantalla no pueden determinar lo que se muestra en una imagen sin texto alternativo, el cual describe el contexto y el significado de la imagen."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Los lectores de pantalla no pueden interpretar tablas sin la estructura apropiada. Los encabezados de tablas brindan orientación y el alcance del contenido."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Los lectores de pantalla no pueden interpretar tablas sin la estructura apropiada. Los subtítulos de las tablas describen el contexto y la comprensión general de la tabla."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Los lectores de pantalla no pueden interpretar tablas sin la estructura apropiada. Los encabezados de tablas brindan orientación y una descripción del contenido."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "Buscar"
  },
  "select_audio_source_21043cd5": {
    "message": "Seleccionar fuente de audio"
  },
  "select_crop_shape_d441feeb": {
    "message": "Seleccionar forma de corte"
  },
  "select_language_7c93a900": {
    "message": "Seleccionar idioma"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Seleccionar fuente de video"
  },
  "selected_274ce24f": {
    "message": "Seleccionado"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "{ linkFileName } seleccionado"
  },
  "selection_b52c4c5e": {
    "message": "Selección"
  },
  "set_header_scope_8c548f40": {
    "message": "Establecer alcance del encabezado"
  },
  "set_minus_b46e9b88": {
    "message": "Fijar menor"
  },
  "set_table_header_cfab13a0": {
    "message": "Establecer encabezado de la tabla"
  },
  "sharp_music_ab956814": {
    "message": "Sostenido (música)"
  },
  "shift_arrows_4d5785fe": {
    "message": "MAYÚS + Flechas"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Mayúsc-O para abrir el editor html agradable."
  },
  "shortcut_911d6255": {
    "message": "Atajo"
  },
  "show_all_967a90f0": {
    "message": "Mostrar todos"
  },
  "show_audio_options_b489926b": {
    "message": "Mostrar opciones de audio"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Mostrar opciones de imágenes"
  },
  "show_link_options_545338fd": {
    "message": "Mostrar opciones de enlace"
  },
  "show_studio_media_options_a0c748c6": {
    "message": "Mostrar opciones de contenido multimedia en Studio"
  },
  "show_video_options_6ed3721a": {
    "message": "Mostrar opciones de video"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Los usuarios detectados navegan rápido por las páginas web, buscando títulos grandes o en negrita. Los usuarios del lector de pantalla solo utilizan los encabezados para una comprensión contextual. Los encabezados deben tener la estructura apropiada."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Los usuarios detectados navegan rápido por las páginas web, buscando títulos grandes o en negrita. Los usuarios del lector de pantalla solo utilizan los encabezados para una comprensión contextual. Los encabezados deben ser concisos dentro de la estructura apropiada."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (variante)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Imagen de un solo color"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Imagen de un solo color"
  },
  "size_b30e1077": {
    "message": "Tamaño"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "El tamaño del archivo de subtítulos es superior al tamaño del archivo permitido de { max } kB."
  },
  "small_b070434a": {
    "message": "Pequeño"
  },
  "solid_circle_9f061dfc": {
    "message": "Círculo continuo"
  },
  "something_went_wrong_89195131": {
    "message": "Algo salió mal."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Algo salió mal al intentar acceder a su cámara web."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Algo salió mal y no sé qué mostrarle."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Algo salió mal. Verifique su conexión, vuelva a cargar la página y vuelva a intentarlo."
  },
  "something_went_wrong_d238c551": {
    "message": "Se produjo un error."
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Ocurrió un problema al compartir su pantalla."
  },
  "sort_by_e75f9e3e": {
    "message": "Organizar según"
  },
  "spades_suit_b37020c2": {
    "message": "Espadas (palo)"
  },
  "square_511eb3b3": {
    "message": "Cuadrado"
  },
  "square_cap_9ec88646": {
    "message": "Extremo cuadrado"
  },
  "square_cup_b0665113": {
    "message": "Copa cuadrada"
  },
  "square_root_e8bcbc60": {
    "message": "Raíz cuadrada"
  },
  "square_root_symbol_d0898a53": {
    "message": "Símbolo de raíz cuadrada"
  },
  "square_subset_17be67cb": {
    "message": "Subconjunto cuadrado"
  },
  "square_subset_strict_7044e84f": {
    "message": "Subconjunto cuadrado (estricto)"
  },
  "square_superset_3be8dae1": {
    "message": "Superconjunto cuadrado"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Superconjunto cuadrado (estricto)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "lista cuadrada no ordenada"
  },
  "star_8d156e09": {
    "message": "Estrella"
  },
  "start_over_f7552aa9": {
    "message": "Volver a empezar"
  },
  "start_recording_9a65141a": {
    "message": "Comenzar grabación"
  },
  "steel_blue_14296f08": {
    "message": "Azul acero"
  },
  "studio_media_options_ee504361": {
    "message": "Opciones de contenido multimedia de Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Bandeja de opciones de contenido multimedia de Studio"
  },
  "styles_2aa721ef": {
    "message": "Estilos"
  },
  "submit_a3cc6859": {
    "message": "Entregar"
  },
  "submitting_b90fac62": {
    "message": "Presentando…"
  },
  "subscript_59744f96": {
    "message": "Subíndice"
  },
  "subset_19c1a92f": {
    "message": "Subconjunto"
  },
  "subset_strict_8d8948d6": {
    "message": "Subconjunto (estricto)"
  },
  "succeeds_9cc31be9": {
    "message": "Sigue"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Sigue al igual"
  },
  "sum_b0842d31": {
    "message": "Suma"
  },
  "superscript_8cb349a2": {
    "message": "Superíndice"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Superíndice y subíndice"
  },
  "superset_c4db8a7a": {
    "message": "Superconjunto"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superconjunto (estricto)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Tipos de archivos admitidos: SRT o WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Cambiar al Editor de HTML acondicionado"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Cambiar al Editor de HTML en crudo"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Cambiar al editor html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Cambiar al editor de texto enriquecido"
  },
  "syllabus_f191f65b": {
    "message": "Programa"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Audio del sistema activado"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Audio del sistema desactivado"
  },
  "tab_arrows_4cf5abfc": {
    "message": "Tabulador/flechas"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Encabezado de tabla que comienza con { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabla que comienza con { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Los encabezados de las tablas deben especificar el alcance."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Las tablas deben incluir un subtítulo que describa el contenido de la tabla."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Las tablas deben incluir al menos un encabezado."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Verde azulado"
  },
  "text_7f4593da": {
    "message": "Texto"
  },
  "text_background_color_16e61c3f": {
    "message": "Color del fondo del texto"
  },
  "text_color_acf75eb6": {
    "message": "Color del texto"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "El texto es difícil de leer si no hay contraste suficiente entre el texto y el fondo, especialmente para aquellas personas con visión reducida."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "El texto de tamaño mayor de 18pt (o 14pt en negrita) debe mostrar una relación de contraste mínima de 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Texto (opcional)"
  },
  "text_position_8df8c162": {
    "message": "Posición del texto"
  },
  "text_size_887c2f6": {
    "message": "Tamaño del texto"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "El texto de tamaño menor de 18pt (o 14pt en negrita) debe mostrar una relación de contraste mínima de 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Todavía se está procesando la vista previa del documento. Inténtelo de nuevo más tarde."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "El primer título de una página debe ser un H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Se redujo la altura del área de contenido enriquecido."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Aumentó la altura del área de contenido enriquecido."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "El material es de dominio público"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "El material tiene licencia Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "El material está sujeto a una excepción, como el uso legítimo, el derecho de cita u otros en virtud de las leyes aplicables de derechos de autor."
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "No se puede acceder al editor html agradable desde el teclado. Presione Mayúsc O para abrir el editor HTML sin formato."
  },
  "therefore_d860e024": {
    "message": "Entonces"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (variante)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Flecha gruesa hacia abajo"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Flecha gruesa izquierda"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Flecha gruesa hacia la izquierda"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Flecha gruesa derecha"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Flecha gruesa hacia la derecha"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Flecha gruesa hacia arriba"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Este documento no se puede mostrar en Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Esta ecuación no se puede representar en vista básica."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Esta imagen no está disponible actualmente"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Este video puede contener anuncios de YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Aunque su video tendrá el título correcto en el navegador, no pudimos actualizarlo en la base de datos."
  },
  "thumbnail_e0de666f": {
    "message": "Miniatura"
  },
  "timebar_a4d18443": {
    "message": "Barra de tiempo"
  },
  "title_ee03d132": {
    "message": "Título"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "A publicarse: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Por hacer: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Alternar { summary } grupo"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Activar/desactivar descripción emergente"
  },
  "tools_2fcf772e": {
    "message": "Herramientas"
  },
  "top_66e0adb6": {
    "message": "Arriba"
  },
  "tray_839df38a": {
    "message": "Bandeja"
  },
  "triangle_6072304e": {
    "message": "Triángulo"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Trinquete (da resultados)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "presione Control F9 para acceder a las opciones de imagen. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "presione Control F9 para acceder a las opciones de enlace. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "presione Control F9 para acceder a las opciones de tabla. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "No se pudo determinar la url de selección de recursos"
  },
  "underline_applied_ae01ec97": {
    "message": "Subrayado aplicado"
  },
  "underline_removed_3693e17c": {
    "message": "Subrayado eliminado"
  },
  "union_e6b57a53": {
    "message": "Unión"
  },
  "unpublished_dfd8801": {
    "message": "no publicado"
  },
  "untitled_16aa4f2b": {
    "message": "Sin título"
  },
  "untitled_efdc2d7d": {
    "message": "sin título"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Flecha diagonal hacia arriba y a la izquierda"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Flecha diagonal hacia arriba y a la derecha"
  },
  "up_c553575d": {
    "message": "Arriba"
  },
  "updated_link_a827e441": {
    "message": "Enlace actualizado"
  },
  "upload_document_253f0478": {
    "message": "Cargar documento"
  },
  "upload_file_fd2361b8": {
    "message": "Cargar archivo"
  },
  "upload_image_6120b609": {
    "message": "Cargar imagen"
  },
  "upload_media_ce31135a": {
    "message": "Cargar multimedia"
  },
  "upload_record_media_e4207d72": {
    "message": "Cargar/grabar contenido multimedia"
  },
  "uploading_19e8a4e7": {
    "message": "Cargando"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "lista ordenada alfabéticamente en mayúsculas"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta en mayúsculas"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma en mayúsculas"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda en mayúsculas"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega en mayúsculas"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi en mayúsculas"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi en mayúsculas"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi en mayúsculas"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "lista ordenada de números romanos en mayúsculas"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma en mayúsculas"
  },
  "uppercase_theta_49afc891": {
    "message": "Theta en mayúsculas"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Ípsilon en mayúsculas"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi en mayúsculas"
  },
  "upsilon_33651634": {
    "message": "Ípsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Flecha apuntando hacia arriba y hacia abajo"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Flecha (gruesa) apuntando hacia arriba y hacia abajo"
  },
  "upward_arrow_9992cb2d": {
    "message": "Flecha hacia arriba"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Triángulo apuntando hacia arriba"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Derecho de uso:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Derechos de uso (obligatorio)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Use las teclas de flecha para navegar entre las opciones."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Utilice las teclas de flecha para seleccionar una forma."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Utilice las teclas de flecha para seleccionar un tamaño."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Usar las teclas de flechas para seleccionar la posición del texto."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Usar las teclas de flechas para seleccionar el tamaño del texto."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Utilice las teclas de flecha para seleccionar un tamaño de contorno."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Utilizado por lectores de pantalla para describir el contenido de un { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Utilizado por los lectores de pantalla para describir el contenido de una imagen"
  },
  "used_by_screen_readers_to_describe_the_video_37ebad25": {
    "message": "Usado por lectores de pantalla para describir el video"
  },
  "user_documents_c206e61f": {
    "message": "Documentos del usuario"
  },
  "user_files_78e21703": {
    "message": "Archivos del usuario"
  },
  "user_images_b6490852": {
    "message": "Imágenes del usuario"
  },
  "user_media_14fbf656": {
    "message": "multimedia del usuario"
  },
  "vector_notation_cf6086ab": {
    "message": "Vector (notación)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Barra vertical (notación de conjuntos)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Puntos verticales"
  },
  "video_options_24ef6e5d": {
    "message": "Opciones de video"
  },
  "video_options_tray_3b9809a5": {
    "message": "Bandeja de opciones de video"
  },
  "video_player_b371005": {
    "message": "Reproductor de video"
  },
  "video_player_for_9e7d373b": {
    "message": "Reproductor de video para "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Reproductor de video para { title }"
  },
  "video_url_889d3263": {
    "message": "URL del video"
  },
  "view_all_e13bf0a6": {
    "message": "Ver todos"
  },
  "view_ba339f93": {
    "message": "Ver"
  },
  "view_description_30446afc": {
    "message": "Ver descripción"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Ver los accesos directos de teclado"
  },
  "view_title_description_67940918": {
    "message": "Ver descripción { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Ver recuento de palabras y caracteres"
  },
  "waiting_for_response_1efd0c50": {
    "message": "Esperando respuesta"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "No pudimos detectar un micrófono operativo conectado a su dispositivo."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "No pudimos detectar una cámara web operativa conectada a su dispositivo."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "No pudimos detectar una cámara web o un micrófono operativo conectado a su dispositivo."
  },
  "webcam_disabled_30c66986": {
    "message": "Cámara web desactivada"
  },
  "webcam_fe91b20f": {
    "message": "Cámara web"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Las páginas web solo deben tener un único H1, que lo usa de manera automática el título de la página. El primer título de su contenido debe ser un H2."
  },
  "what_would_you_like_to_do_6dc0d541": {
    "message": "¿Qué desea hacer?"
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Cuando se usa el marcado que formatea visualmente los ítems como una lista, pero no indica la relación de la lista, los usuarios pueden tener dificultades para navegar por la información."
  },
  "white_87fa64fd": {
    "message": "Blanco"
  },
  "why_523b3d8c": {
    "message": "Por qué"
  },
  "width_492fec76": {
    "message": "Ancho"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "El ancho y la altura deben ser números"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height } px"
  },
  "wiki_home_9cd54d0": {
    "message": "Página de Inicio de Wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Conteo de palabras"
  },
  "words_b448b7d5": {
    "message": "Palabras"
  },
  "wreath_product_200b38ef": {
    "message": "Producto en corona"
  },
  "writing_assistant_a30ac16a": {
    "message": "Asistente de redacción"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Sí"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Se encuentra en una paleta de colores. Para navegar en la paleta hacia arriba, a la izquierda, hacia abajo o a la ''W'', ''A'', ''S'' y ''D'', respectivamente"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Está en un deslizador de color. Para navegar el deslizador a la izquierda o a la derecha, use los botones ''A'', y ''D'', respectivamente"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Está en un deslizador alfa. Para navegar el deslizador a la izquierda o a la derecha, use los botones ''A'', y ''D'', respectivamente"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Tiene cambios sin guardar en la bandeja de Icon Maker. ¿Desea continuar sin guardar esos cambios?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Es posible que tenga que ajustar los títulos adicionales para mantener la jerarquía de las páginas."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "No puede cargar un archivo vacío."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "La imagen se ha comprimido para Icon Maker. Las imágenes inferiores a { size } KB no se comprimirán."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Su micrófono está bloqueado en la configuración del navegador."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Su cámara web y micrófono están bloqueados en la configuración del navegador."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Su cámara web está bloqueada en la configuración del navegador."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Es posible que su cámara web ya esté en uso."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL incrustada de YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Ampliar imagen"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Alejar imagen"
  }
};
formatMessage.addLocale({
  es: locale
});